// eslint-disable-next-line
// @ts-nocheck
import { filter } from 'lodash';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// material
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Modal,
  Switch,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListToolbar } from '../../sections/@dashboard/bookings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getParkingSpaces, getParkingTotalRecords, setParkings } from '../../store/state/parkingSlice';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import {
  useDeleteParkingSpaceLocationByIdMutation,
  useGetAllParkingSpaceLocationMutation,
} from '../../store/api/parkingsApi';
import toast from 'react-hot-toast';
import Loading from '../../components/Loading';
import { styled } from '@mui/material/styles';
import { checkPermissions } from '../../sections/@dashboard/parkingspaces/utility';
import { PERMISSION } from '../../utils/userPermission';

const TABLE_HEAD = [
  { id: 'name', label: 'Model Name', alignRight: false },
  { id: 'regi. no', label: 'Reg. No', alignRight: false },
  { id: 'slots', label: 'Seating Capacity', alignRight: false },
  { id: 'address', label: 'Address', alignRight: false },
  { id: 'vendorName', label: 'Vendor Name', alignRight: false },
  { id: 'vendorCode', label: 'Vendor Code', alignRight: false },
  { id: 'ParkingStatus', label: 'Vehicle Status', alignRight: false },
];

const ResponsiveBox = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    flexDirection: 'column',
  },
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    flexDirection: 'row',
  },
}));

const MarginBox = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    marginTop: '10px',
    width: '100%',
  },
  [theme.breakpoints.up('md')]: {},
}));
// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '10px',
  p: '30px',
  px: '50px',
};

function capitalizeFirstLetter(string) {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default function AllParkingSpaces() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const parkingSpacesData = useAppSelector(getParkingSpaces);
  const parkingTotalRecords = useAppSelector(getParkingTotalRecords);
  const [parkingSpaces, setParkingSpaces] = useState([]);
  const [deleteParkingSpaceLocationById, deleteResponse] = useDeleteParkingSpaceLocationByIdMutation();
  const [getAllParkingSpaceLocation, getAllResponse] = useGetAllParkingSpaceLocationMutation();
  const [getAllPendingParkingSpaceLocation, getAllPendingResponse] = useGetAllParkingSpaceLocationMutation();
  const [open, setOpen] = useState(false);
  const [parkingId, setParkingId] = useState<number>();
  const token = JSON.parse(localStorage.getItem('login')) || null;
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [pendingParkingCount, setPendingParkingCount] = useState(0);
  const loginDetails = JSON.parse(localStorage.getItem('login') || '{}');
  const userType = loginDetails.userType;

  useEffect(() => {
    if (parkingSpacesData) {
      setParkingSpaces(parkingSpacesData);
    }
  }, [parkingSpacesData]);

  useEffect(() => {
    getAllParkingSpaceLocation({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        currentStage: 'active',
      },
    });
    setFilterName('')
  }, []);

  useEffect(() => {
    getAllPendingParkingSpaceLocation({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        currentStage: 'pending',
      },
    });
  }, []);

  useEffect(() => {
    if (getAllPendingResponse.isSuccess) {
      setPendingParkingCount(getAllPendingResponse.data?.totalRecords);
    }
    if (getAllPendingResponse.isError) {
      let errorData: any = getAllPendingResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [getAllPendingResponse.isSuccess, getAllPendingResponse.isError]);

  useEffect(() => {
    if (deleteResponse.isSuccess) {
      getAllParkingSpaceLocation({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          currentStage: 'active',
        },
      });
      toast.success('Parking space updated successfully');
    }
    if (deleteResponse.isError) {
      let errorData: any = deleteResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [deleteResponse.isSuccess, deleteResponse.isError]);

  useEffect(() => {
    if (getAllResponse.isSuccess) {
      dispatch(setParkings(getAllResponse.data));
    }
    if (getAllResponse.isError) {
      let errorData: any = getAllResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [getAllResponse.isSuccess, getAllResponse.isError]);

  const filteredUsers = parkingSpaces;
  const isUserNotFound = filteredUsers.length === 0;

  function LinkTab(props) {
    return (
      <Tab
        component="a"
        onClick={(event) => {
          event.preventDefault();
        }}
        {...props}
      />
    );
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = parkingSpaces.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllParkingSpaceLocation({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: newPage,
        currentStage: 'active',
      },
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getAllParkingSpaceLocation({
      token: token.token,
      payload: {
        offset: parseInt(event.target.value, 10),
        page: 0,
        currentStage: 'active',
      },
    });
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    dispatch(
      getAllParkingSpaceLocation({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          name: event.target.value,
          currentStage: 'active',
        },
      })
    );
  };

  const cancelDelete = () => {
    setOpen(false);
  };

  const handleDelete = async () => {
    await deleteParkingSpaceLocationById({
      id: parkingId,
      token: token.token,
    });
    setOpen(false);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Page title="Vehicle Overview">
      {checkPermissions(PERMISSION.PARKING_SPACE_ALL, token.permissions) ? (
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" marginBottom={0} gutterBottom>
              Vehicle Overview
            </Typography>
            <ResponsiveBox>
              <Box>
                <Button
                  style={{
                    marginRight: '10px',
                    color: 'white',
                    backgroundColor: '#E23744',
                  }}
                  size="large"
                  variant="contained"
                  onClick={() => {
                    navigate('/dashboard/new-vehicle-requests');
                  }}
                >
                  New Vehicle Request ({pendingParkingCount})
                </Button>
              </Box>
              {userType !== 'UTSA' && (
                <MarginBox>
                  <Button
                    variant="contained"
                    style={{
                      color: 'white',
                      backgroundColor: '#E23744',
                    }}
                    onClick={() => {
                      navigate('/dashboard/addvehicle', { state: { isAdmin: true, editMode: false } });
                    }}
                    startIcon={<Iconify icon="eva:plus-fill" />}
                    size="large"
                  >
                    Add
                  </Button>
                </MarginBox>
              )}
            </ResponsiveBox>
          </Stack>
          <Card sx={{ marginTop: '20px' }}>
            <BookingListToolbar
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
              placeholder={'Search By Name'}
            />
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <AllParkingsListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={parkingSpaces.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers.length > 0 &&
                      filteredUsers.map((row) => {
                        const { id, name, serviceProviderDetailResponseDTO, address, capacity, status, vehicleDetailObj } = row;
                        const isItemSelected = selected.indexOf(name) !== -1;
                        return (
                          <TableRow
                            hover
                            key={id}
                            tabIndex={-1}
                            role="checkbox"
                            selected={isItemSelected}
                            aria-checked={isItemSelected}
                          >
                            <TableCell align="left">
                              <Typography
                                fontWeight="bold"
                                variant="subtitle2"
                                whiteSpace={'nowrap'}
                                onClick={() => {
                                  navigate('/dashboard/addvehicle', {
                                    state: { id: id, editMode: true, isAdmin: true },
                                  });
                                }}
                                style={{
                                  color: 'blue',
                                  cursor: 'pointer',
                                }}
                              >
                                {vehicleDetailObj?.model === null ? 'No Name Available' : vehicleDetailObj?.model}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography variant="body2">{vehicleDetailObj?.registrationNumber}</Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography
                                variant="body2"
                              >
                                {vehicleDetailObj?.seatingCapacity}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography variant="body2">{address}</Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography variant="body2">{capitalizeFirstLetter(serviceProviderDetailResponseDTO?.name)}</Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography variant="body2">{capitalizeFirstLetter(serviceProviderDetailResponseDTO?.vendorAlias)}</Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Stack direction="row" justifyContent={'center'} alignItems="center">
                                <Switch
                                  checked={status}
                                  onClick={() => {
                                    setParkingId(id);
                                    handleOpen();
                                  }}
                                />
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterName} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={parkingTotalRecords || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        </Container>
      ) : null}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" textAlign={'center'} variant="h4" gutterBottom>
            Are you sure?
          </Typography>
          <Stack direction="row" justifyContent={'center'} alignItems={'center'}>
            <Button
              variant="contained"
              onClick={cancelDelete}
              sx={{ margin: '10px' }}
              style={{ color: 'white', backgroundColor: '#E23744' }}
            >
              No
            </Button>
            <Button
              variant="contained"
              onClick={handleDelete}
              sx={{ margin: '10px' }}
              style={{ color: 'white', backgroundColor: '#E23744' }}
            >
              Yes
            </Button>
          </Stack>
        </Box>
      </Modal>
      {deleteResponse.isLoading || getAllResponse.isLoading ? <Loading /> : null}
    </Page>
  );
}
